export default '/pricing/identity-theft';
